<template>
  <main class="dashboard links">
    <div class="mb-4">
      <h2><b>Список слайдов</b></h2>


      <BackButton></BackButton>
    </div>
    {{ slide?.elements }}

    <div class="screen-list">


      <div class="layout-wrapper">
        <div class="form" v-if="slide">
        <div class="item">
          <label for="">Название</label>
          <input type="text" class="form-control" v-model="slide.name">
        </div>
        <div class="item" v-if="slide">
          <label for="">Шаблон</label>
          <select class="form-control select" name="" id="" v-model="slide.layout_name">
            <option v-for="layout_name in layouts" :value="layout_name.name">{{layout_name.name}}</option>
          </select>
        </div>
        <div class="item">
          <label for="">Тип проекта</label>
           <MultiSelect
                      v-model="slide.project_types"
                      :options="[{id: 'audit', name: 'Аудит'},{id: 'active', name: 'Активный'},]"
                      :multi="true"
                      :only_value="true"
                      name=""></MultiSelect>
        </div>
        <div class="item">
          <div class="form-check form-switch ms-1 pt-2">
          <input class="form-check-input" v-model="slide.for_country" type="checkbox" role="switch"
                           id="for_country">
                    <label class="form-check-label" for="for_country">Для всех стран</label>
        </div>
        </div>
        <div class="item">
          <div class="form-check form-switch ms-1 pt-2">
                    <input class="form-check-input" v-model="slide.is_enabled" type="checkbox" role="switch"
                           id="enabled">
                    <label class="form-check-label" for="enabled">Активен</label>
                  </div>
        </div>
        <button class="btn btn-outline-dark btnm-sm">Сохранить</button>
          </div>
        <h4>{{ layout?.name }}</h4>
        <div class="layout" id="layout"
             :style="{width: unitToPx(layout?.slide_width), height: unitToPx(layout?.slide_height)}">
          <template v-if="layout">
            <template v-for="icon in slide.icons">
              <div class="icons" :title="icon.name">
                <SvgBlock :icon="icon"></SvgBlock>
              </div>

            </template>
            <template v-for="place in layout.placeholders">
              <div class="placeholder" :title="place.name"
                   :style="{width: unitToPx(place.width), height: unitToPx(place.height), top: unitToPx(place.top), left: unitToPx(place.left)}">
                <!--                <span class="badge">{{ place.name }}</span>-->
                <template v-for="block in slide.text_blocks?.filter(x=>x.placeholder===place.name)">
                  <template v-for="text in block.texts">
                    <TextBlock :text="text" :placeholder="place"></TextBlock>
                  </template>
                </template>
                <template v-for="element in slide.elements?.filter(x=>x.position===place.name)">
                  <element-block :element="element"></element-block>
                </template>

                <button class="add-element btn btn-sm btn-outline-dark" @click="place.edit=!place.edit"
                        title="Добавить элемент">+
                </button>
                <div class="btn-group-vertical add-elements" v-if="place.edit" role="group">
                  <button type="button" class="btn btn-outline-dark"
                          @click="slide.text_blocks.filter(x=>x.placeholder===place.name)[0].texts.push({text: '', edit: true}); place.edit=false;">
                    Текст
                  </button>
                  <button type="button" class="btn btn-outline-dark" @click="place.show_element=!place.show_element">
                    Элемент
                  </button>
                  <button type="button" class="btn btn-outline-dark">Изображение</button>
                </div>
                <div class="btn-group-vertical add-elements custom" v-if="place.edit&&place.show_element" role="group">
                  <button type="button" v-for="(element, key) in elements" @click="slide.elements.push({position: place.name, element: key});place.show_element=false;" class="btn btn-outline-dark">{{ element }}
                  </button>
                </div>
              </div>
            </template>
<!--            <template v-for="place in layout.icons">-->
<!--              <div class="icons" :title="place.name">-->
<!--                <SvgBlock :svgContent="place.svg"-->
<!--                          :width="unitToPx(place.width)"-->
<!--                          :height="unitToPx(place.height)"-->
<!--                          :top="unitToPx(place.top)"-->
<!--                          :left="unitToPx(place.left)"-->

<!--                ></SvgBlock>-->
<!--              </div>-->
<!--            </template>-->
          </template>

        </div>
      </div>
      <div class="layout-icons">
        <template v-for="icon in icons">
          <div class="icon" :style="{width: unitToPx(icon?.width), height: unitToPx(icon?.height)}">
            <SvgBlock :svgContent="icon.svg"
                      :width="unitToPx(icon.width)"
                          :height="unitToPx(icon.height)"
                          :top="'auto'"
                          :left="'auto'"></SvgBlock>
            <!--            <span class="badge">{{ icon.name }}</span>-->
            <!--            <template v-html="icon.svg"></template>-->
          </div>
        </template>
      </div>
    </div>


  </main>
</template>

<script>

import HTTP from "@/api/common";
import {SlideApi} from "@/api/slides";
import TextBlock from "@/views/report_slide/components/TextBlock.vue";
import SvgBlock from "@/views/report_slide/components/SvgBlock.vue";
import ElementBlock from "@/views/report_slide/components/ElementBlock.vue";

export default {
  name: 'SlideList',
  data() {
    return {
      icons: [],
      layout_name: null,
      layout: null,
      layouts: [],
      slide: null,
      elements: {
        "toc": "Содержание",
        "icon_selector": "Фигура по условию",
        "abc": "Тезисы и % негатива по странам",
        "top20": "ТОП20 таблица",
        "country_summary": "Таблица-Резюме по стране",
        "keywords_list": "Список запросов",
        "negative_links_counter": "Счетчик нежелательных ссылок по стране",
        "snippets": "Примеры выдачи (сниппеты)",
        "ch_overflow": "Изменяемый при наложении",
        "wiki": "Википедия",
        "hints": "Подсказки",
        "knowledge": "Блок знаний",
        "search_block": "Поисковый блок (картинки/видео/похожие)",
        "delete_if_has_data": "Удалить текущий, если есть данные из настроек"

      }
    }
  },
  components: {TextBlock, SvgBlock, ElementBlock},
  watch: {
    layout_name(val) {
      if (val) this.getLayout(val.name)
    },
    "slide.layout_name"(val) {
      if (val) this.getLayout(val)
    }
  },
  mounted: function () {

SlideApi.layouts().then(response => this.layouts = response)
    const $this = this;
    if (this.$route.params.slide_id) SlideApi.slide_detail(this.$route.params.slide_id).then(response => {
      $this.slide = response
      $this.getLayout($this.slide.layout_name)
    })
    else {
      this.slide = {
        name: "",
        project_types: []
      }
    }
    // SlideApi.icons().then(response => {
    //   $this.icons = response
    // })
    // HTTP.get(`slide_icons/`).then((response) => {
    //   $this.icons = response.data;
    //   setTimeout($this.setDraggable, 500)
    // });
    // this.getLayout("Ссылки")
  },
  computed: {},
  methods: {

    unitToPx(unit, addPX = true) {
      return `${(unit / 12700) * 1.333}${addPX ? 'px' : ''}`
    },
    getLayout(name) {
      SlideApi.layout_detail(name).then(response => this.layout = response)
    },

    setDraggable() {
      const container = document.getElementById('layout');
      const draggables = document.querySelectorAll('.draggable');

      draggables.forEach(draggable => {
        draggable.addEventListener('mousedown', (e) => {
          e.preventDefault();

          draggable.classList.add("dragging")
          const shiftX = e.clientX - draggable.getBoundingClientRect().left;
          const shiftY = e.clientY - draggable.getBoundingClientRect().top;

          function moveAt(pageX, pageY) {
            // Ограничение внутри контейнера
            const containerRect = container.getBoundingClientRect();
            // let newX = pageX - shiftX - containerRect.left;
            // let newY = pageY - shiftY - containerRect.top;
            let newX = pageX;
            let newY = pageY;

            // границы
            // newX = Math.max(0, Math.min(newX, containerRect.width - draggable.offsetWidth));
            // newY = Math.max(0, Math.min(newY, containerRect.height - draggable.offsetHeight));
            //
            draggable.style.left = `${newX}px`;
            draggable.style.top = `${newY}px`;
            draggable.classList.remove("dragging")
          }

          function onMouseMove(e) {
            moveAt(e.clientX, e.clientY);
          }

          document.addEventListener('mousemove', onMouseMove);

          document.addEventListener('mouseup', () => {
            document.removeEventListener('mousemove', onMouseMove);
          }, {once: true});
        });
      });
    }

  }
}

</script>

<style scoped lang="scss">

.draggable {
  cursor: move;
  user-select: none;

  &.dragging {
    opacity: 0.5;
    position: absolute;

  }

  .resize-handle {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 10px;
    height: 10px;
    background: #555;
    cursor: nwse-resize;
  }
}


.screen-list {
  display: flex;
  gap: 30px;

  ul {
    height: 80vh;
    overflow-y: scroll;
  }
}

.add-element {
  position: absolute;
  right: -20px;
  top: -20px;
  height: 20px;
  width: 20px;
  line-height: 10px;
  padding: 0;
  background: #fff;
}
.form{
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 959px;
}

.add-elements {
  background: #fff;
  position: absolute;
  right: -130px;
  top: 0;
  z-index: 100;

  &.custom {
    right: 0;
  }
}

.layout-wrapper {

  .layout {
    display: block;
    border: 1px solid #999;
    position: relative;

    .placeholder {
      z-index: 1;
      border: 1px solid #999;
      position: absolute;
      display: block;
      background: repeating-linear-gradient(
              45deg,
              rgba(255, 255, 255, 0.2),
              rgba(255, 255, 255, 0.2) 10px,
              transparent 10px,
              transparent 20px
      );
      line-height: normal;

      span {
        font-size: 8px;
      }

      .badge {
        background: #ccc;
        border-radius: 5px;
        color: #000000;
        font-size: 9px;
        padding: 0;
        line-height: 10px;
        top: -10px;
        position: absolute;
      }
    }

    .icons {
      z-index: 0;
      //border: 1px solid #000;
      position: absolute;
      display: block;
      //background: #74637f;

    }
  }
}

//.icon {
//background: repeating-linear-gradient(
//        45deg,
//        rgba(53, 102, 121, 0.5),
//        rgba(53, 102, 121, 0.5) 10px,
//        transparent 10px,
//        transparent 20px
//);
//position: absolute;
//}
</style>
